import axios from 'axios'
import { Message } from 'element-ui'
import Lang from '@/lang'
import router from '@/router'

if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' +
  window.location.hostname +
  (window.location.port ? ':' + window.location.port : '')
}
var rootPath = window.location.origin
var timeZone = localStorage.getItem('timeZone')
var token = localStorage.getItem('token')
var language = localStorage.getItem('language')

const service = axios.create({
  baseURL: rootPath,
  timeout: 5000,
  headers: {
    'x-us-authtype': '1',
    'x-us-token': token,
    'accept-language': language,
    'time-zone': timeZone
  }
})
service.interceptors.response.use(
  response => response,
  error => {
    const errorBasePath = function () {
      let pathArray = error.request.responseURL.split('/')
      pathArray.length = 3
      const path = pathArray.join('/')
      return path
    }
    let fromAddress = error.request.responseURL.split('/').pop()
    if (error.request.readyState === 4 && error.request.status === 0 && errorBasePath() === window.location.origin) {
      Message({
        message: 'Error: ' + Lang.ui.app.l150,
        type: 'error',
        duration: 3 * 1000
      })
    }
    if (error.response.data.errno) {
      if (error.response.data.errno === 226) {
        return Promise.reject(error)
      }
      if (error.response.data.errno === 101) {
        localStorage.removeItem('token')
        localStorage.removeItem('completeNum')
        localStorage.removeItem('transferInfo')
        window.location.reload()
      } else if (error.response.data.errno === 165) {
        Message({
          message: 'Error: ' + Lang.ui.app.l221,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 100) {
        Message({
          message: 'Error: ' + Lang.ui.app.l222,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 158) {
        Message({
          message: 'Error: ' + Lang.ui.app.l223,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 206 || error.response.data.errno === 1206) {
        if (fromAddress === 'invite') {
          Message({
            message: 'Error: ' + Lang.systemError.l206,
            type: 'warning',
            duration: 3 * 1000
          })
        } else {
          Message({
            message: 'Error: ' + Lang.systemError.l206,
            type: 'warning',
            duration: 3 * 1000
          })
          localStorage.removeItem('token')
          localStorage.removeItem('completeNum')
          localStorage.removeItem('transferInfo')
          router.push({ path: '/app/login' })
        }
      } else if (error.response.data.errno === 251 || error.response.data.errno === 1251) {
        Message({
          message: 'Error: ' + Lang.systemError.l251,
          type: 'warning',
          duration: 3 * 1000
        })
        localStorage.removeItem('token')
        localStorage.removeItem('completeNum')
        localStorage.removeItem('transferInfo')
        router.push({ path: '/app/login' })
      } else if (error.response.data.errno === 291 || error.response.data.errno === 1291) {
        Message({
          message: 'Error: ' + Lang.ui.app.l224,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 292 || error.response.data.errno === 1292) {
        Message({
          message: 'Error: ' + Lang.ui.app.l225,
          type: 'warning',
          duration: 3 * 1000
        })
        localStorage.removeItem('token')
        localStorage.removeItem('completeNum')
        localStorage.removeItem('transferInfo')
        router.push({ path: '/app/login' })
      } else if (error.response.data.errno === 296) {
        Message({
          message: 'Error: ' + Lang.ui.app.l226,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 297) {
        Message({
          message: 'Error: ' + Lang.ui.app.l227,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 298) {
        Message({
          message: 'Error: ' + Lang.ui.app.l228,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 299) {
        Message({
          message: 'Error: ' + Lang.systemError.l299,
          type: 'warning',
          duration: 3 * 1000
        })
      } else if (error.response.data.errno === 300) {
        Message({
          message: 'Error: ' + Lang.systemError.l300,
          type: 'warning',
          duration: 3 * 1000
        })
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      } else {
        var errorNum = 'l' + error.response.data.errno
        Message({
          message: 'Error' + error.response.data.errno + ': ' + Lang.systemError[errorNum],
          type: 'warning',
          duration: 3 * 1000
        })
      }
    } else {
      if (error.response.status === 404) {
        return
      }
      Message({
        message: 'Error: ' + error.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)
export default service
